import { makeStyles } from "@material-ui/core/styles";
import { Colors } from "constants/constants";

export const useStyles = makeStyles((theme) => ({
  tableHeadCell: {
    cursor: "default",
    textAlign: "center",
    padding: theme.spacing(1.5, 1.5, 1.5, 4),
  },
  tableHeadWhiteCell: {
    background: Colors.WHITE,
  },
  tableHeadTypography: {
    fontSize: 16,
    fontWeight: 600,
    textWrap: "nowrap",
  },
  labelwithArrow: {
    "& .MuiSvgIcon-root": {
      opacity: 0.5,
    },
    "&.Mui-disabled": {
      "& .MuiSvgIcon-root": {
        opacity: 0,
      },
    },
  },
  fontWeight: {
    fontWeight: 700,
    fontSize: "18px",
  },
}));
